import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/typo3': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M178.7 78.4c0 66.4 83.4 264.9 140.6 264.9 6.9 0 11.5 0 18.5-2.3-49.4 79.5-110.4 139-146.7 139-77.3 0-184.1-234-184.1-337.5 0-16.3 3.9-29.4 9.3-37.1 27-32.4 106.8-57.9 176.3-66.4-8.5 7-13.9 14.7-13.9 39.4zM301.5 32c71.8 0 138.8 11.6 138.8 52.5 0 82.6-52.5 182.3-78.8 182.3-47.9 0-101.7-132.1-101.7-198.5 0-30.9 11.6-36.3 41.7-36.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/typo3.js
// module id = 1062
// module chunks = 0